export var flipPixels = function (pixels, width, height) {
    var halfHeight = Math.floor(height / 2);
    var bytesPerRow = width * 4;
    // make a temp buffer to hold one row
    var temp = new Uint8Array(width * 4);
    for (var y = 0; y < halfHeight; ++y) {
        var topOffset = y * bytesPerRow;
        var bottomOffset = (height - y - 1) * bytesPerRow;
        // make copy of a row on the top half
        temp.set(pixels.subarray(topOffset, topOffset + bytesPerRow));
        // copy a row from the bottom half to the top
        pixels.copyWithin(topOffset, bottomOffset, bottomOffset + bytesPerRow);
        // copy the copy of the top half row to the bottom half
        pixels.set(temp, bottomOffset);
    }
    return pixels;
};
//# sourceMappingURL=imageData.js.map